import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    private _isLoadingSubject = new BehaviorSubject<boolean>(false);
    public isLoading$ = this._isLoadingSubject.asObservable();

    showLoader() {
        this._isLoadingSubject.next(true);
    }
    hideLoader() {
        this._isLoadingSubject.next(false);
    }
}